module.exports = "https://static.wanderu.com/static/media/ie.5ecf710f.svg";